<template>
  <!--Basic Information Card-->
  <div>
    <v-card-title primary-title>
      <span class="title">Basic Information</span>
    </v-card-title>
    <v-slide-y-transition mode="out-in">
      <v-card-text class="pt-0">
        <v-form ref="form">
          <v-container fluid>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="client"
                  label="Client Name"
                  prepend-icon="mdi-account"
                  class="input-data"
                  required
                  :rules="[v => !!(v || '').trim() || 'Required']"
                  @change="onChange($event)"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-combobox
                  v-model="exchange"
                  :items="exchanges"
                  label="Select exchange"
                  prepend-icon="mdi-chart-line"
                  class="input-data"
                ></v-combobox>
              </v-flex> 
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
    </v-slide-y-transition>
  </div>
</template>
<script>
import { type } from 'os'
export default {
  props: {
    basic: { type: Object, require: true },
    valid: { type: Boolean, require: true },
    exchanges: { type: Array }
  },
  computed: {
    client: {
      get() {
        return this.basic.client
      },
      set(val) {}
    },
    exchange: {
      get() {
        return this.basic.exchange
      },
      set(val) {
        this.$emit('exchange', val)
      }
    }
  },
  methods: {
    onChange(value) {
      value = value.toUpperCase()
      this.$emit('client', value)
    }
  }
}
</script>